var custom = {
  init: function(){
  	custom.sliderHome();
    custom.searchExpand();
    custom.sliderCategory();
    custom.countDown();
    custom.mapMarket();
    custom.sidebarStickitCustom();
    custom.quantityNum();
    custom.sliderGallery();
    custom.hourReserv();
    custom.socialTeacher();
    custom.icoWhats();
    custom.clickVideo();
    custom.sliderConfM();
    custom.videoIframe();
  },
  token:"",
  _timeZone:"",
  sliderHome: function(){
    if($(".slider-home").length){
      $('.slider-home').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear'
      });
      $('.slider-home').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slider-info').removeClass('aos-init').removeClass('aos-animate');
      });
      $('.slider-home').on('afterChange', function(event, slick, currentSlide, nextSlide){
        AOS.refresh();
      });
    }
  },
  searchExpand: function(){
    function buttonUp(){
      var inputVal = $('.searchbox-input').val();
      inputVal = $.trim(inputVal).length;
      if( inputVal !== 0){
        $('.searchbox-icon').css('display','none');
      } else {
        $('.searchbox-input').val('');
        $('.searchbox-icon').css('display','block');
      }
    }
    var submitIcon = $('.searchbox-icon');
    var inputBox = $('.searchbox-input');
    var searchBox = $('.searchbox');
    var isOpen = false;
    submitIcon.click(function(){
      if(isOpen == false){
        searchBox.addClass('searchbox-open');
        inputBox.focus();
        isOpen = true;
      } else {
        searchBox.removeClass('searchbox-open');
        inputBox.focusout();
        isOpen = false;
      }
    });  
    submitIcon.mouseup(function(){
      return false;
    });
    searchBox.mouseup(function(){
      return false;
    });
    $(document).mouseup(function(){
      if(isOpen == true){
        $('.searchbox-icon').css('display','block');
        submitIcon.click();
      }
    });
  },
  countDown: function(){
    if($(".listTiempo").length){
      $('[data-countdown]').each(function () {
        var $this = $(this);
        var finalDate = $(this).data('countdown');
        var timeZone = $(this).data('timezone');        
        var newFinalDateTZ = finalDate;
        if (moment && timeZone) {
          console.log('timezone');
          var momentDate = moment.tz(finalDate, timeZone);
          newFinalDateTZ = momentDate.toDate();
        }        
        
        $this.countdown(newFinalDateTZ, function (event) {
            $this = $(this).html(event.strftime(''
            + '<div><span class="datos-tiempo">%D</span><em>Días</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%H</span><em>Horas</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%M</span><em>Min</em></div><span>:</span>'
            + '<div><span class="datos-tiempo">%S</span><em>Seg</em></div>'
            ));
        });
      });
    }
  },
  sliderCategory: function(){
    if($(".slider-category").length){
      $('.slider-category').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  },
  mapMarket: function(){
    if($(".map-canvas").length){
      $(".mapShow").click(function(e){
        e.preventDefault();
        $(".mapShow").remove();
        $(".map-canvas").addClass("map-show");
        var lat = $(".map-canvas").data("lat");
        var log = $(".map-canvas").data("lon");
        var direc = $(".map-canvas").data("direc");

        var map = new google.maps.Map($('.map-canvas')[0], {
            zoom: 16,
            center: new google.maps.LatLng(lat,log)
        });
        var marker = new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(lat,log)
        });
        var info = new SnazzyInfoWindow({
            marker: marker,
            closeOnMapClick: false,
            content: direc
        });
        info.open();
      });
    }
  },
  sidebarStickitCustom: function(){
    if($('.sidebar-stickit-custom').length){
      $('.sidebar-stickit-custom').stickit({
        screenMinWidth: 992,
        top: 60
      });
    }  
  },
  toggleUserCourse: function(e){
    if($(".info-text-autor").hasClass("toggle-active")){
      $(".toggle-click").removeClass("a-toggle");
      $(".info-text-autor").removeClass("toggle-active");
    }else{
      $(".toggle-click").addClass("a-toggle");
      $(".info-text-autor").addClass("toggle-active");
    }
  },
  quantityNum: function(){
    if($('.quantity').length){
      $('.add-l').click(function () {
        var dataMax = $(this).data('max');
        if ($(this).prev().val() < dataMax) {
          $(this).prev().val(+$(this).prev().val() + 1);
        }
      });
      $('.sub-l').click(function () {
        if ($(this).next().val() > 1) {
          if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
        }
      });
    }
  },
  sliderGallery: function(){
    if($(".inner-gallery-event").length){
      $('.popup-gallery-lead').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Cargando imagen #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
          tError: '',
          titleSrc: function(item) {
            return item.el.attr('title');
          }
        }
      });
    }
  },
  hourReserv: function(){
    if($(".block-calendar-reserv").length){

       $('#datepickerMent').datepicker({
         language: "es",
         todayHighlight: true
       });

      if($('.footer-calendar-m').length){
        $(".hour-select").customSelect();
      }
      $(".event-resv").click(function(){
         var eventR = $(this);
         eventR.hide();
         eventR.parent("li").find(".resv-btn").show();
      });
    }
  },
  socialTeacher: function(){
    $(".up-social").click(function(){
      if($(this).parent(".downActive").length){
        $(this).parent(".social-teacher").removeClass("downActive");
      }else{
        $(this).parent(".social-teacher").addClass("downActive");  
      }
    });
  },
  icoWhats: function(){
     if($("#block-whats").length){
      var navigationContainer = $('#block-whats'),
      mainNavigation = navigationContainer.find('#cd-main-whats .block-nav-m');
      $('.cd-whats-trigger').on('click',function(e){
        e.preventDefault();
        $(this).toggleClass('menu-is-open');
        mainNavigation.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend').toggleClass('is-visible');
      });
    }
  },
  clickVideo: function(){
    if($(".video-m").length){
      $(".video-m").click(function(){
        $(this).hide();
        $(this).siblings('.b-content-video').show();
        $(this).siblings('.b-content-video').addClass('video-concl');
      });
    }
    if($(".video-iframe-t").length){
      $(".video-iframe-t").click(function(){
        $(this).hide();
        $(this).siblings('.b-content-video').show();
        $(this).siblings('.b-content-video').addClass('video-concl');
      });
    }
    $('#reserveModal').on('hidden.bs.modal', function (event) {
      $("#block-reserv-c").show();
      $("#listHourCalendar").hide();
      $(".btn-return").hide();
    });
  },
  videoIframe: function(){
    $(".item-video").click(function(){
      var htmlVideo = $(this).find(".hidden-video").html();
      var linkSrc = $(this).data("video");
      $('#videoModal').modal('show');
      $("#course-video-content").html(htmlVideo);
      setTimeout(function(){
        $("#course-video-content").find("iframe").attr("src", linkSrc);
      }, 200);
    });
    $('#videoModal').on('hidden.bs.modal', function (event) {
      $("#course-video-content").find("iframe").attr('src', '');
    });
  },
  sliderConfM: function(){
    if($(".slider-conf-m").length){
      $('.slider-conf-m').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 320,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
} 